<template>
    <div class="artcleMain">
        <p class="current">当前位置：<span>搜索</span></p>
        <div class="artcle-box">
            <div class="menu" v-if="IsEnable">
                <el-menu
                    
                    ref="menu"
                    @select="handleMenuSelect"
                    class="el-menu-vertical-demo"
                    default-active="1"
                    background-color="#fff"
                    text-color="#000"
                    active-text-color="#00a8a8">
                        <el-menu-item index="1" @click="getListcompany1()">看政策</el-menu-item>
                        <el-menu-item index="2" @click="getExpert()">问专家</el-menu-item>
                        <el-menu-item index="3" @click="getListcompany()">找服务商</el-menu-item>
                        <el-menu-item index="4" @click="listProduct()">询服务</el-menu-item>
                        <el-menu-item index="5" @click="getEnable()">商品搜索</el-menu-item>
                       
                </el-menu>
            </div>
            <div class="artcle-right" v-show="IsMenu != 3">
                <div class="search-page" style="margin-bottom: 20px;">
                    <Search style="margin-bottom: 40px;width: 600px;" @inputKey="inputKey" :Newkeywords="Newkeywords"></Search>
                </div>
                <div v-for="item in listarticle" :key="item.id" style="" v-show="IsMenu != 4">
                    <div v-show="IsMenu == 1">
                        <div class="content-div" @click="handleDetail(item)" >
                            <img :src="item.firstFile.FileUrl" alt="" v-show="item.firstFile.FileUrl">
                            <img src="../../assets/logo666.png" alt="" v-show="!item.firstFile.FileUrl">
                            <div>
                                <p class="title-p">{{ item.title }}</p>
                                <p class="time-p">{{ item.create_time }}</p>
                            </div>
                        
                        </div>
                        <el-divider   ></el-divider>
                    </div>
                    <div  v-show="IsMenu == 2">
                        <div class="content-div Menu2" @click="handleCompanyDetail(item)">
                            <img :src="item.firstFile.FileUrl" alt="" v-show="item.firstFile.FileUrl">
                            <img src="../../assets/logo666.png" alt="" v-show="!item.firstFile.FileUrl">
                            <div>
                                <p class="title-p ">{{ item.name }}</p>
                                <p class="time-p">{{ item.description }}</p>
                            </div>
                        </div>
                        <el-divider   ></el-divider>
                    </div>
                </div>
                <div v-show="IsMenu == 4">
                    <div class="productBox">
                        <div class="productItem"  v-for="item in listarticle" :key="item.id" @click="getExpertId(item.id)">
                            <div :style="'width: 265px; height: 170px;background-image:url('+item.firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;'"
                                v-show="item.firstFile.FileUrl"
                            ></div>
                            <p> {{ item.name }} </p>
                            <span> {{ item.price }}</span>
                        </div>
                    </div>
                </div>
                <div v-show="IsMenu == 5">
                    <div :class="IsEnable?'enable-list': 'enableFalse-list'">
                        <div v-for="item in exableList.items" :key="item.id" class="list-item" @click="handleExableInfo(item)">
                            <div class="commodityImage" :style="'background-image:url('+item.firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;'"></div>
                            <p class="description" style="height: 45px;">{{item.name}}</p>
                            <p style="height: 20px;">{{item.company_name}}</p>
                            <p>订货编码：CG8894</p>
                            <p>制造商型号：10172476</p>
                            <div class="enableFh">
                                <!-- <div>当日发货</div> -->
                                <div>{{item.att_item_price_size}}种规格</div>
                            </div>
                            <div class="price" v-if="IsToken">
                                <div>
                                    <p class="colorProce"><span>￥</span>{{item.price}} </p>
                                    <span>/{{ item.unit }}</span> 
                                    <!-- <div class="vipPrice"><p>￥20.99</p>会员价</div> -->
                                </div>
                                <!-- <div>
                                    <i class="el-icon-circle-plus" style="cursor: pointer;"></i>
                                </div> -->
                            </div>
                            <!-- <div class="youhui">
                                <span>多买多惠</span>
                            </div> -->
                            <!-- <p class="price">
                                
                                
                                <span style="margin-left: 5px;font-size: 14px;color: #8c8c8c;text-decoration-line: line-through;">{{ item.oprice }}</span>
                            
                            </p> -->
                        </div>
                        
                    </div>
                </div>
                <div class="pagination">
                    <el-pagination
                        :hide-on-single-page="hideOnSinglePage"
                        :page-size="20"
                        :pager-count="widthNew?11:5"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
            <expertList v-show="IsMenu == 3" :recommendIds="''" :type="type" :wacthMenu="wacthMenu" :Newkeywords="Newkeywords" @GetNewkeywords="GetNewkeywords"></expertList>
        </div>
    </div>
</template>

<script>
import Search from "../search/index.vue"
import expertList from "../expert/expertList.vue";
export default({
    data(){
        return{
            innerWidth: '',
            input: '',
            total: 0,
            hideOnSinglePage: true,
            currentChange: 1,
            cate_values: ['maintype','industry'],
            listarticle: [],
            channel: sessionStorage.getItem("channel"),
            maintype_ids: '',
            currentName: '',
            Newkeywords:'',
            IsMenu: 1,
            indexActive: 1,
            wacthMenu: false,
            type: 2,
            widthNew: false,
            exableList: '',
            IsToken: false,
            IsEnable: true
        }
    },
    components: {
        Search,
        expertList
    },
    watch: {
       
      
    },
    methods:{
        handleMenuSelect(index) {
            console.log('Selected Index:', index);
            this.indexActive = index
        },
        getTimeDate(timeDate){
            const year = timeDate.getFullYear();
                const month = (timeDate.getMonth() + 1).toString().padStart(2, '0');
                const day = timeDate.getDate().toString().padStart(2, '0');
                const hours = timeDate.getHours().toString().padStart(2, '0');
                const minutes = timeDate.getMinutes().toString().padStart(2, '0');
                const seconds = timeDate.getSeconds().toString().padStart(2, '0');
                const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

                return formattedDate
        },
        //   根据不同的channel来查询
        getListArry(data){
            this.$store.dispatch('menu/ChannelPolicyList',data)
                .then(res => {
                
                    if(res.ok){
                        this.listarticle = res.data.items
                        this.total = res.data.total

                        if(this.total <= 20){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                    
                    console.log("?????????????????????????");
                    console.log(this.listarticle);
                    this.listarticle.map(item => {
                        const timeDate = new Date(item.create_time)
                        item.create_time = this.getTimeDate(timeDate)
                    })

                   


                }).catch(err => {
                    console.log(err);s
                })
        },
        getListcompany1(){
            this.IsMenu = 1
            let data = {
                channel: 'policy',
                pageNum: 1,
                pageSize: 10,
                recommendIds: '',
                keywords: this.Newkeywords
            }
            
            this.getListArry(data)
        },
        getListcompany(){
            this.IsMenu = 2
            let data = {
                pageNum: 1,
                pageSize: 10,
                cates: '',
                keywords: this.Newkeywords
            }
            this.getIndexActive(data)
            
        },
        getExpert(){
            this.IsMenu = 3
            this.type = 2
            this.wacthMenu = !this.wacthMenu
        },
        getIndexActive(data){
            this.$store.dispatch('menu/listcompany',data)
                .then(res => {
                    console.log("listLo---------------");
                    console.log(res);
                    this.listarticle = res.data.items
                    this.total = res.data.total
                    
                    if(this.total <= 10){
                        this.hideOnSinglePage = true
                    }else{
                        this.hideOnSinglePage = false
                    }
                })
        },
        handleExableInfo(item){
            const { href } = this.$router.resolve({
                path: "/enableInfo",
                query: {
                    id: item.id,
                }
            });
            window.open(href, '_blank');
        },
        company(){
            this.$router.push({
                path: '/join'
            })
        },  

        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            this.currentChange = val
            if(this.IsMenu != 4){
                let data = {
                    channel: 'policy',
                    pageNum: val,
                    pageSize: 10,
                    recommendIds: '',
                    keywords: this.Newkeywords
                }
                this.getListArry(data)
            }else if(this.IsMenu == 4){
                let data = {
                    pageNum: val,
                    pageSize: 9,
                    recommendIds: '',
                    keywords:  this.Newkeywords,
                }
                this.handleListProduct(data)
            }else if(this.IsMenu == 5){
                let items = {
                    pageNum: val,
                    pageSize: 20,
                    cate: '',
                    sub_cate: '',
                    s_sub_cate: '',
                    keywords: this.Newkeywords,
                    product_types: [ 'product','jifen','service'],
                    sort_type: '',
                    sort_value: '',
                }
                this.gesListEnable(items)
            }
        },
        handleDetail(item){
            console.log("aidfjdfldjf-----");
            console.log(item);
            this.$router.push({
                path: '/detailPages',
                query:{
                    key: item.id,
                    currentName: this.currentName
                }
            })
        },
        handleCompanyDetail(item){
          this.$router.push({
            path: '/companyDetail',
            query: {
                key: item.id,
                currentName: '公司详情'
            }
          })
        },  
        inputKey(val){
            this.Newkeywords = val
            if( this.IsMenu == 1 ){
                let data = {
                    channel: 'policy',
                    pageNum: 1,
                    pageSize: 10,
                    recommendIds: '',
                    keywords: val
                }
                this.getListArry(data)
            }else if( this.IsMenu == 2 ){
                
                let data = {
                    pageNum: 1,
                    pageSize: 10,
                    cates: '',
                    keywords: val
                }
                this.getIndexActive(data)
            }else if( this.IsMenu == 4 ){
                let data = {
                    pageNum: 0,
                    pageSize: 9,
                    recommendIds: '',
                    keywords:  this.Newkeywords,
                }
                this.handleListProduct(data)
            }else if( this.IsMenu == 5 ){
                this.getEnable()
            }
            
        },
        GetNewkeywords(val){
            console.log("llllllllllllllllllllllllllllllluuuuuuuuuuuuuuuuuuuuuu");
            console.log(val);
            this.Newkeywords = val
        },
        listProduct(){
            this.IsMenu = 4
            let data = {
                pageNum: 0,
                pageSize: 9,
                recommendIds: '',
                keywords:  this.Newkeywords,
            }
            this.handleListProduct(data)
        },
        getEnable(){
            
            this.IsMenu = 5
            let items = {
                pageNum: 1,
                pageSize: 20,
                cate: '',
                sub_cate: '',
                s_sub_cate: '',
                keywords: this.Newkeywords,
                product_types: [ 'product','jifen','service'],
                sort_type: '',
                sort_value: '',
            }
            this.gesListEnable(items)
        },
        gesListEnable(data){
            this.$store.dispatch('enable/listproduct',data)
                .then(res => {
                    if(res.ok){
                        this.exableList = res.data
                        this.total = res.data.total

                        if(this.total <= 20){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }

                    }
                })
        },
        handleListProduct(data){
            this.$store.dispatch('home/listproduct',data)
                .then(res => {
                    if (res.ok) {
                        this.listarticle = res.data.items

                        this.total = res.data.total
                    
                        if(this.total <= 10){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                })
        },
        getExpertId(id){
            this.$router.push({
                path: '/detailInfo',
                query: {
                    id: id,
                    type: 1
                }
            })
        }
    },
    mounted(){
        this.Newkeywords = this.$route.query.val

        let path = sessionStorage.getItem('path')
        if(path == '/funeng' || path == '/enableInfo' || path == '/enable'){
            this.IsEnable = false
            this.getEnable()
        }else{

            
            let data = {
                channel: 'policy',
                pageNum: 1,
                pageSize: 10,
                recommendIds: '',
                keywords: this.$route.query.val
            }
        
            this.getListArry(data)
        }
    },
    
    created(){
        
        
        if(localStorage.getItem('token')){
            this.IsToken = true
        }else{
            this.IsToken = false
        }
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        // this.currentName = sessionStorage.getItem("name")
        // this.channel = sessionStorage.getItem("channel")
        // this.recommendIds = sessionStorage.getItem("recommendIds")
    //    if(this.$route.query.channel == 'law'){
        
    }
})
</script>

<style>
@import url(../../css/channelPolicy.css);
</style>

<style scoped lang="scss">
.productBox{
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
    align-items: center;
}
.productItem{
    padding: 10px 10px;
    width: 265px;
    margin: 0px 20px 20px 0px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    cursor: pointer;
}
.productItem p{
    font-size: 20px;height: 40px;
    line-height: 40px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.productItem span{
    font-size: 20px;
    color: #999999;
}
.enable-list{
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
    cursor: pointer;
    .list-item{
        width: 285px;
        margin: 10px 6px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        font-size: 14px;
        color: #999999;
        padding: 5px 5px 8px 5px;
        .commodityImage{
            width: 285px;
            height: 300px;
        }
        .description{
    
            margin: 10px 0 10px 0;
            color: #333;
            font-size: 18px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            
        }
        .enableFh{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 10px;
            div{
                margin-right: 10px;
                padding: 3px 5px;
                background: #ffe9c2;
                color: #333;
            }
            
        }
        .price{
            display: flex;
            justify-content: space-between;
            align-items: end;
            font-size: 16px;
            margin-top: 10px;
            width: 99%;
            div{
                display: flex;
                justify-content: flex-start;
                align-items: end;
                .colorProce{
                    font-size: 18px;
                    color: #ff2f4f;
                }
                .vipPrice{
                    padding-right: 5px;
                    font-size: 14px;
                    margin-left: 10px;
                    color: #fff;
                    border: 1px solid black;
                    background: #000;
                    align-items: center;
                    p{
                        padding: 2px 3px;
                        border-top-right-radius: 8px;
                        background: #fff;
                        color: #333;
                        margin-right: 5px;
                    }
                }
            }
            span{
                font-size: 14px;
            }
            i{
                color: #00acc9;
                float: right;
            }
        }
        .youhui{
            margin-top: 10px;
            span{
                padding: 3px 5px;
                color: #ff2f4f;
                border: 1px solid #ff2f4f;
            }
        }
    }
}

.enableFalse-list{
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
    cursor: pointer;
    .list-item{
        width: 360px;
        margin: 10px 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        font-size: 14px;
        color: #999999;
        padding: 5px 5px 8px 5px;
        .commodityImage{
            width: 360px;
            height: 300px;
        }
        .description{
    
            margin: 10px 0 10px 0;
            color: #333;
            font-size: 18px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            
        }
        .enableFh{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 10px;
            div{
                margin-right: 10px;
                padding: 3px 5px;
                background: #ffe9c2;
                color: #333;
            }
            
        }
        .price{
            display: flex;
            justify-content: space-between;
            align-items: end;
            font-size: 16px;
            margin-top: 10px;
            width: 99%;
            div{
                display: flex;
                justify-content: flex-start;
                align-items: end;
                .colorProce{
                    font-size: 18px;
                    color: #ff2f4f;
                }
                .vipPrice{
                    padding-right: 5px;
                    font-size: 14px;
                    margin-left: 10px;
                    color: #fff;
                    border: 1px solid black;
                    background: #000;
                    align-items: center;
                    p{
                        padding: 2px 3px;
                        border-top-right-radius: 8px;
                        background: #fff;
                        color: #333;
                        margin-right: 5px;
                    }
                }
            }
            span{
                font-size: 14px;
            }
            i{
                color: #00acc9;
                float: right;
            }
        }
        .youhui{
            margin-top: 10px;
            span{
                padding: 3px 5px;
                color: #ff2f4f;
                border: 1px solid #ff2f4f;
            }
        }
    }
}
</style>